/**
 * Componente para proteger rutas que requieren autenticación
 * Redirige al login si el usuario no está autenticado
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/modules/auth/context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    // Usamos BASE_URL para asegurar que siempre regrese a la raíz de la app
    // sin importar qué tan profundo esté el usuario en las rutas.
    const loginPath = `${import.meta.env.BASE_URL}auth/login`;
    
    // Nota: Si usas HashRouter, React Router maneja internamente el '#'
    return <Navigate to={loginPath} replace />;
  }

  return <>{children}</>;
}

